export default {
  bgColor: {
    '#000000': 'bg-primary-black',
    '#505050': 'bg-primary-charcoal',
    '#F2F2F2': 'bg-primary-offWhite',
    '#ffffff': 'bg-primary-white',
    '#1f3e74': 'bg-primary-marineBlue',
    '#2b5195': 'bg-primary-airForceBlue',
    '#5586d4': 'bg-primary-riverBlue',
    '#379302': 'bg-green-base',
    '#b1ed8e': 'bg-green-light',
    '#e9ffdd': 'bg-green-pastel',
    '#296f01': 'bg-green-dark',
    '#f48036': 'bg-orange-base',
    '#ffcc85': 'bg-orange-light',
    '#fff4cf': 'bg-orange-pastel',
    '#b94c09': 'bg-orange-dark',
    '#ba1d4c': 'bg-magenta-base',
    '#6d7782': 'bg-raven-base',
    '#681f74': 'bg-purple-base',
    '#f3bc2a': 'bg-gold-base',
    '#F8D472': 'bg-gold-light',
    '#BE8B09': 'bg-gold-dark',
    '#f43a36': 'bg-red-base',
    '#ffaba8': 'bg-red-light',
    '#ba0e0a': 'bg-red-dark',
    '#feeeee': 'bg-red-pastel',
    '#939393': 'bg-neutral-darkGray',
    '#c0c0c0': 'bg-neutral-trueGray',
    '#dcdcdc': 'bg-neutral-stoneGray',
    '#ebebeb': 'bg-neutral-doveGray',
    '#0799f8': 'bg-action-brightBlue',
    '#e6f5fe': 'bg-action-lightBlue',
    '#006BC2': 'bg-action-darkBrightBlue',
    '#162d5b': 'bg-blue-navy',
    '#406cb4': 'bg-blue-mutedBlue',
    '#6ac2fb': 'bg-blue-lightBrightBlue',
    '#1877f2': 'bg-externalBrand-facebookPrimary1'
  }
};
//# sourceMappingURL=classes.js.map